import { render } from "./OptionItem.vue?vue&type=template&id=8cfa8e30"
import script from "./OptionItem.vue?vue&type=script&lang=js"
export * from "./OptionItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__